<template>
  <div class="comtent" @click="handleOutsideNavClick">

    <!-- 右侧导航栏 -->
    <div class="nav-bar" :class="{ 'nav-open': isNavOpen }">
      <ul>
        <li><a href="#" @click="cliText(0)" :class="{ active: color == 0 }">
            <img v-if="color == 0" src="@/assets/shouye_icon2.png" alt="" class="img-0">
            <img v-else src="@/assets/shouye_icon1.png" alt="" class="img-0">
            {{ $t('content5') }}</a></li>
        <li><a href="#" @click="cliText(1)" :class="{ active: color == 1 }">
            <img v-if="color == 1" src="@/assets/fukuanchanpin_icon2.png" alt="" class="img-0">
            <img v-else src="@/assets/fukuanchanpin_icon1.png" alt="" class="img-0">
            {{ $t('content6') }}</a></li>
        <li><a href="#" @click="cliText(2)" :class="{ active: color == 2 }">
            <img v-if="color == 2" src="@/assets/zhifupingtai_icon2.png" alt="" class="img-0">
            <img v-else src="@/assets/zhifupingtai_icon1.png" alt="" class="img-0">
            {{ $t('content7') }}</a></li>
        <li>
          <a href="#" @click.prevent="toggleSubMenu('industry')" :class="{ active: color == 3 }">
            <img v-if="color == 3" src="@/assets/hangye_icon2.png" alt="" class="img-03">
            <img v-else src="@/assets/hangye_icon1.png" alt="" class="img-03">
            {{ $t('content8') }}
            <img v-if="arrow" src="@/assets/Slice 37.png" alt="" class="img-04">
            <img v-else src="@/assets/Slice 36.png" alt="" class="img-04">
          </a>
          <ul v-if="subMenus.industry" class="sub-menu">
            <li :class="{ 'selected': isSubMenuSelected(3, 0) }"><a href="#" @click="index1">{{ $t('content9') }}</a></li>
            <li :class="{ 'selected': isSubMenuSelected(3, 1) }"><a href="#" @click="index2">{{ $t('content10') }}</a></li>
            <li :class="{ 'selected': isSubMenuSelected(3, 2) }"><a href="#" @click="index3">{{ $t('content11') }}</a></li>
            <li :class="{ 'selected': isSubMenuSelected(3, 3) }"><a href="#" @click="index4">{{ $t('content12') }}</a></li>
          </ul>
        </li>
        <li><a href="#" @click="cliText(4)" :class="{ active: color == 4 }">
            <img v-if="color == 4" src="@/assets/guanyu_icon2.png" alt="" class="img-0">
            <img v-else src="@/assets/guanyu_icon1.png" alt="" class="img-0">
            {{ $t('content13') }}</a></li>
      </ul>
    </div>
    <!-- 原有的内容 -->
    <img src="@/assets/shouye_bg@2x.png" class="comtent-img" alt="">
    <div class="title-box" id="title-box">
      <img src="@/assets/uxpay_logo.png" @click="cliText(0)" :class="{ actives: color == 0 }" class="text1" alt="">
      <div class="pos-s">
        <div class="custom-select" @click="toggleDropdown">
          <img src="@/assets/Slice 51.png" alt="" class="slice-51">
          <span id="textZH"></span>
          <img src="@/assets/xiala_icon@2x.png" class="xiala" alt="">
        </div>
        <ul class="dropdown-options" v-if="isDropdownOpen">
          <li v-for="item in options" :key="item.value" @click="selectOption(item)">{{ item.label }}</li>
        </ul>
      </div>
      <div class="pos-a"> {{ $t('content14') }}</div>
      <!-- 切换导航栏按钮 -->
      <button @click="toggleNav" class="nav-toggle">
        <img src="@/assets/Slice 38.png" alt="">
      </button>
    </div>
    <home v-if="color == 0"></home>
    <pay v-if="color == 1"></pay>
    <ment v-if="color == 2"></ment>
    <regarding v-if="color == 4"></regarding>

    <div class="open-box" v-if="color == 3 && ft" @mouseenter="ft = true" @mouseleave="ft = false">
      <div class="open-flex" :class="{ activeOpen: opencli == 0 }" @click="openclis(0)">
        <img src="@/assets/yongjin_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content9') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 1 }" @click="openclis(1)">
        <img src="@/assets/fafang_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content10') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 2 }" @click="openclis(2)">
        <img src="@/assets/gongyingshang_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content11') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 3 }" @click="openclis(3)">
        <img src="@/assets/youxi_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content12') }}</div>
      </div>
    </div>

    <soliv1 v-if="color == 3 && opencli == 0"></soliv1>
    <soliv2 v-if="color == 3 && opencli == 1"></soliv2>
    <soliv3 v-if="color == 3 && opencli == 2"></soliv3>
    <soliv4 v-if="color == 3 && opencli == 3"></soliv4>


    <div :class="$i18n.locale + '_bottom-Filmny'">
      <img src="@/assets/uxpay_logo.png" class="con-img" alt="">
      <div class="bottom-Filmny-box">
        <div class="Filmny-left con-0">
          <div class="con-1">{{ $t('content16') }}</div>
          <div class="con-2">
            <img src="@/assets/message1.png" class="con-2-img" alt="">
            <div class="con-3">uxpay@uxpay.com</div>
          </div>
        </div>
        <div>
          <div style="display: flex;" class="con-0">
            <div class="Filmny-text-3">{{ $t('content5') }}</div>
            <div class="Filmny-text-6" @click="payprod">{{ $t('content5') }}</div>
          </div>

          <div class="con-4 con-0">
            <div class="Filmny-text-3">{{ $t('content6') }}</div>
            <div class="Filmny-text-6" @click="goPay">{{ $t('content6') }}</div>
          </div>

          <div class="con-5 con-0">
            <div class="Filmny-text-3">{{ $t('content7') }}</div>
            <div>
              <div  @click="index1" :class="$i18n.locale + '_Filmny-text-9'">{{ $t('content8') }}</div>
              <div  @click="index2" :class="$i18n.locale + '_Filmny-text-9'">{{ $t('content9') }}</div>
              <div  @click="index3" :class="$i18n.locale + '_Filmny-text-9'">{{ $t('content10') }}</div>
              <div  @click="index4" :class="$i18n.locale + '_Filmny-text-9'">{{ $t('content11') }}</div>
            </div>
          </div>

          <div class="con-6 con-0">
            <div class="Filmny-text-3">{{ $t('content13') }}</div>
            <div class="Filmny-text-6" @click="gywm">{{ $t('content13') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="bottom-Filmny-2">
        <!-- <div class="Filmny-text-8">Copyright © 2024 uxpay.com {{$i18n.locale=='zh'?'版权所有':''}}</div> -->
        <div class="Filmny-text-8">Copyright © {{ currentYear }} uxpay.com {{ $i18n.locale == 'zh' ? '版权所有' : '' }}</div>
        <!-- <div class="Filmny-text-8">京ICP备18018888号-1</div> -->
      </div>
    </div>
    <div class="QRCode-box" v-if="showContactWay && showContactWayNumber === 1">
      <div class="contact-QRCode">
        <img src="@/assets/wx_img2.jpg" class="QRCode" alt="">
      </div>
      <div class="QRCode-wenzi">{{ $t('content196') }}</div>
    </div>
     <div class="QRCode-box" v-if="showContactWay && showContactWayNumber === 3">
      <div class="contact-QRCode">
        <img src="@/assets/appicon.png" class="QRCode" alt="">
      </div>
      <div class="QRCode-wenzi">{{ $t('content196') }}</div>
    </div>
    <div class="contact-Email" v-if="showContactWay && showContactWayNumber === 2">
      <div class="youxiang">
        {{ $t('content15') }}
      </div>
      <div class="email">
        uxpay@uxpay.com
      </div>
    </div>
    <div class="relation-box" style="">
      <div>
      <img src="@/assets/wx_icon@2x.png" class="qr-1" alt="" @click="openQRCode(1)">
 <div class="cfont">WeChat</div>
      </div>
      <div class="line-1"></div>
<div>
  <img src="@/assets/en_whatsapp_icon@2x.png" class="qr-1" alt="" @click="openAPP(3)">
   <div class="cfont">whatsapp</div>
</div>
      <div class="line-1"></div>
      <div>
      <img src="@/assets/email_icon@2x.png" class="email-0" alt="" @click="openEmail(2)">
   <div class="cfont">email</div>

      </div>
    </div>
  </div>
</template>


<script>
import home from '@/home/mHomePage'
import pay from '@/pay/mPayPage'
import ment from '@/payment/mPayment'
import regarding from '@/regarding/mRegarding'
import soliv1 from '@/soliv/mIndex1'
import soliv2 from '@/soliv/mIndex2.vue'
import soliv3 from '@/soliv/mIndex3.vue'
import soliv4 from '@/soliv/mIndex4.vue'
import { switchLanguage } from '@/main'
import { toRaw } from '@vue/reactivity'


export default {
  components: {
    home,
    pay,
    ment,
    regarding,
    soliv1,
    soliv2,
    soliv3,
    soliv4

  },
  name: 'App',
  data() {
    return {
      color: 0,
      opencli: 0,
      ft: false,
      showContactWay: false,
      showContactWayNumber: 1,
      options: [
        {
          value: 'zh',
          label: '中文',
        },
        {
          value: 'en',
          label: 'English',
        },
      ],
      value: undefined,
      selectedOption: null,
      isDropdownOpen: false,
      isNavOpen: false, // 导航栏状态
      arrow: false,
      subMenus: {
        industry: false
      },
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    isMobie() {
      return /Android|webOS|iPhone|iPad|iPad por|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    openQRCode(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
     openAPP(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
    openEmail(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
    cliText(index) {
      this.color = index
      this.isNavOpen = false
    },
    itemClick(index) {
      this.color = index
    },
    openclis(index) {
      this.opencli = index
    },
    payprod() {
      this.color = 1
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
      // this.$router.push('/payPage')
    },
    goPay() {
      this.color = 2
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
      // this.$router.push('/payment')
    },
    gywm() {
      this.color = 4
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index1() {
      this.color = 3
      this.opencli = 0
      this.isNavOpen = false
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index2() {
      this.color = 3
      this.opencli = 1
      this.isNavOpen = false
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index3() {
      this.color = 3
      this.opencli = 2
      this.isNavOpen = false
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index4() {
      this.color = 3
      this.opencli = 3
      this.isNavOpen = false
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectOption(item) {
      const rawItem = toRaw(item);
      this.selectedOption = rawItem;
      this.isDropdownOpen = false;
       switchLanguage(rawItem.value)
      window.location.reload() 
      this.$i18n.locale = rawItem.value 
    },
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    handleOutsideNavClick(event) {
      if (event.target.className == 'qr-1' && this.showContactWay) return
      if (event.target.className == 'email-0' && this.showContactWay) return
      if ((event.target.className !== 'QRCode' || event.target.className !== 'qr-1' || event.target.className!== 'QRCode-box') && this.showContactWay) {
        this.showContactWay = false
      }
      if ((event.target.className !== 'contact-Email' || event.target.className !== 'email-0') && this.showContactWay) {
        this.showContactWay = false
      }
      const navBar = this.$el.querySelector('.nav-bar');
      const toggleButton = this.$el.querySelector('.nav-toggle');
      if (event.target.className == 'img-04') return

      if (this.isNavOpen && !navBar.contains(event.target) && !toggleButton.contains(event.target)) {
        this.isNavOpen = false;
      }
    },
    toggleSubMenu(menu) {
      this.arrow = !this.arrow
      // this.color = 3;
      this.subMenus[menu] = !this.subMenus[menu];
      // if (menu === 'industry' && this.subMenus[menu]) {
      //   this.index1();
      // }
    },
    isSubMenuSelected(color, opencli) {
      return this.color === color && this.opencli === opencli;
    }
  },
  mounted() {
    document.getElementById('textZH').textContent = localStorage.getItem('lang') == 'en' ? 'English' : '中文'
    document.addEventListener('click', this.handleOutsideNavClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideNavClick);
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

.comtent-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 1113px;
  z-index: -2;
}

.comtent {
  padding: 0 auto;
  margin: 0 auto;
}

.title-box {
  /* margin-left: 360px; */
  /* margin-top: 24px; */
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 79px;
  position: fixed;
  z-index: 10000;
  width: 100%;
  border-radius: 5px;
  height: 170px;
}

.actives {
  color: #007bff;
  font-weight: 600;
}

.text1 {
  margin-left: 75px;
  padding-bottom: 10px;
  /* width: 120px; */
  height: 102px;
  line-height: 35px
}

.pos-a {
  border-radius: 5px;
  background-color: #4873ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 436px;
  height: 120px;
  font-size: 62px;
  position: absolute;
  right: 260px;
}

.pos-s {
  /* border-radius: 5px;
  background-color: #4873ff; */
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 436px;
  height: 120px;
  font-size: 62px;
  background-color: white;
  position: absolute;
  right: 720px;
}

.zh_bottom-Filmny {
  height: 1200px;
  background-color: #F8F9FF;
  padding-top: 87px;
  cursor: pointer;
  padding-left: 80px;
  padding-bottom: 100px;
}
.en_bottom-Filmny {
  height: 1600px;
  background-color: #F8F9FF;
  padding-top: 87px;
  cursor: pointer;
  padding-left: 80px;
  padding-bottom: 100px;
}

.bottom-Filmny-box {
  width: 1169px;
  /* margin: 0 auto; */
  height: 255px;
  /* display: flex;
  justify-content: space-between; */
  padding-top: 10px;
}

.Filmny-left {
  width: 1700px;
  display: flex;
}

.con-img {
  width: 340px;
  height: 112px;
}

.Filmny-text-3 {
  font-size: 72px;
  color: #333333;
  font-weight: 600;
  width: 600px;
}

.zh_Filmny-text-9 {
  font-size: 72px;
  color: #666666;
  width: 800px;
}
.en_Filmny-text-9 {
  font-size: 72px;
  color: #666666;
  width: 1000px;
  margin-bottom: 50px;
}

.Filmny-text-6 {
  font-size: 72px;
  color: #666666;
}

.open-box {
  width: 323px;
  /* height: 366px; */
  border-radius: 24px;
  background-color: #fff;
  position: absolute;
  left: 626px;
  top: 88px;
  cursor: pointer;
  padding: 15px 0;
  z-index: 1;
}

.open-text {
  font-size: 18px;
  color: #666666;
  margin-left: 17px;
}

.open-flex {
  display: flex;
  align-items: center;
  width: 292px;
  height: 80px;
  margin: 0 auto;
}

.activeOpen {
  width: 292px;
  height: 80px;
  background-color: #F3F6FF;
  border-radius: 15px;
  color: #4873FF;
}

.con-0 {
  margin-top: 40px;
}

.con-1 {
  font-size: 72px;
  color: #333333;
  width: 600px;
}

.con-2 {
  display: flex;
  align-items: center;
}

.con-2-img {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.con-3 {
  margin-left: 9px;
  font-size: 72px;
  color: #333333;
}

.con-4 {
  /* margin-left: 115px; */
  display: flex;
}

.con-5 {
  /* margin-left: 109px; */
  display: flex;
  width: 1700px;
}

.con-6 {
  /* margin-left: 131px; */
  display: flex;
}

.con-8 {
  width: 40px;
  height: 40px;
  margin-left: 27px;
}

.custom-select {
  position: relative;
  /* padding: 8px 12px; */
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: black;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  padding: 8px 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  list-style-type: none;
  z-index: 1000;
}

.dropdown-options li {
  padding: 8px 12px;
  cursor: pointer;
  color: black;
}

.dropdown-options li:hover {
  background-color: #f5f7fa;
}

.slice-51 {
  margin-right: 20px;
  margin-left: 20px;
}

.xiala {
  position: absolute;
  left: 80%;
}

.relation-box {
  width: 280px;
  height: 1200px;
  background-color: #ffffff;
  position: fixed;
  top: 72%;
  right: 1%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  box-shadow: 0px 0px 24px 0px rgba(235,239,250,0.9);;
  text-align: center;
  z-index: 10000;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
}

.qr-1 {
 height: 250px;
  width: 250px;
}

.email-0 {
  height: 250px;
  width: 250px;
}

.contact-QRCode {
  height: 1200px;
  width: 1200px;
  position: fixed;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 10000;
  /* background-color: white; */
  border-radius: 50px;
  /* border: 10px solid #4873ff; */
  padding: 32px;
}
.QRCode-box{
  height: 1600px;
  width: 1500px;
  position: fixed;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 10000;
  background-color: #e1e7ff;
  border-radius: 50px;
}
.QRCode-wenzi{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1400px;
  font-size: 62px;
}
.QRCode {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contact-Email {
  height: 600px;
  border-radius: 50px;
  width: 1300px;
  font-size: 72px;
  position: fixed;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 10000;
  background-color: #e1e7ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.youxiang {
  margin-top: 20px;
}

/* 导航栏切换按钮样式 */
.nav-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  width: 120px;
  height: 120px;
  position: absolute;
  right: 120px;
}

/* 右侧导航栏样式 */
.nav-bar {
  position: fixed;
  top: 0;
  right: -1200px;
  width: 1100px;
  height: 100%;
  background-color: white;
  transition: right 0.3s ease;
  z-index: 10001;
}

.nav-bar ul {
  list-style-type: none;
  padding: 0;
  margin-top: 60px;
}

.nav-bar li {
  padding: 50px;
}

.nav-bar a {
  color: #666666;
  text-decoration: none;
  font-size: 62px;
  display: flex;
  align-items: center;
  padding: 30px;
}

.img-0 {
  margin-right: 40px;
}

.img-03 {
  margin-right: 40px;
}

.img-04 {
  margin-left: 160px;
}

/* 导航栏打开状态 */
.nav-bar.nav-open {
  right: 0;
}

.sub-menu {
  list-style-type: none;
  padding-left: 20px;
}

.sub-menu li {
  /* padding: 20px; */
  padding-left: 120px;
}

.nav-bar li:hover .sub-menu {
  display: block;
}

.nav-bar li,
.nav-bar li a.active {
  color: #007bff;
  /* 可根据需求修改字体颜色 */
}

.active {
  color: #007bff;
}

.sub-menu li.selected {
  background-color: #EEF2FF;
  border-left: 6px solid #007bff;
}
.bottom-Filmny-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 80px;
  background-color: #F8F9FF;
  color: #666666;
  font-size: 16px;
  border-top: #292929 4px solid;
}
.Filmny-text-8{
  font-size: 72px;
}
.cfont {
  font-size: 62px;
}

.line-1 {
 height: 1px;
    background-color: #666666;
    width: 160px;
    margin-bottom: 20px;
    margin-top: 20px;
}
</style>
